// <auto-generated>
// This file is automatically generated from DSL.
// Do not modify this file directly. Changes will be overwritten.
// Source: dsl/entities/DocumentTemplate.yaml
// Generated: 2026-07-07T12:10:40.852Z
// </auto-generated>

import { JsonSchema, UISchemaElement } from '@jsonforms/core';

/** Extended JsonSchema that allows custom properties like enumNames, x-lookup, enumSource. */
type ExtendedJsonSchema = JsonSchema & Record<string, unknown>;

/**
 * JSON Schema for DocumentTemplate (CREATE)
 */
export const DocumentTemplateCreateSchema = {
  "type": "object",
  "title": "DocumentTemplate",
  "description": "Tenant-editable HTML/Scriban template backing a printed PDF document (invoice, offer, ...)",
  "properties": {
    "name": {
      "title": "Name",
      "description": "Display name for this template",
      "type": "string",
      "maxLength": 200
    },
    "documentType": {
      "title": "Document type",
      "description": "Logical document type this template backs",
      "type": "string",
      "enum": [
        "INVOICE"
      ],
      "enumNames": [
        "Invoice"
      ],
      "enumOrdinals": [
        0
      ],
      "enumType": "DocumentTemplateType"
    },
    "htmlContent": {
      "title": "Template HTML",
      "description": "HTML with Scriban placeholders, authored via the template editor",
      "type": "string"
    },
    "isActive": {
      "title": "Active",
      "description": "Only active templates are eligible to be selected at render time",
      "type": "boolean",
      "default": true
    },
    "isDefault": {
      "title": "Default for document type",
      "description": "When true, this is the tenant default template for its documentType",
      "type": "boolean",
      "default": false
    },
    "pageSetupId": {
      "title": "Page setup",
      "description": "Page configuration (paper size, margins, orientation) used when rendering this template; renderer defaults apply when empty",
      "type": [
        "string",
        "null"
      ],
      "format": "entity-lookup",
      "x-lookup": {
        "entity": "DocumentPageSetup",
        "module": "core",
        "displayField": "name",
        "searchFields": [
          "name"
        ],
        "additionalFields": [
          "paperFormat"
        ],
        "minSearchLength": 0,
        "pageSize": 20,
        "recentlyUsedSlot": "core.DocumentTemplate.pageSetupId"
      }
    },
    "description": {
      "title": "Description",
      "description": "Optional free-text notes about this template",
      "type": [
        "string",
        "null"
      ]
    }
  },
  "required": [
    "name",
    "documentType",
    "htmlContent",
    "isActive",
    "isDefault"
  ]
} as unknown as ExtendedJsonSchema;

/**
 * UI Schema for DocumentTemplate (CREATE)
 */
export const DocumentTemplateCreateUiSchema: UISchemaElement = {
  "type": "GridLayout",
  "options": {
    "columns": 12,
    "density": "compact",
    "variant": "standard"
  },
  "elements": [
    {
      "type": "Group",
      "label": "Details",
      "elements": [
        {
          "type": "Control",
          "scope": "#/properties/name",
          "options": {
            "gridColumn": "span 6"
          }
        },
        {
          "type": "Control",
          "scope": "#/properties/documentType",
          "options": {
            "gridColumn": "span 6"
          }
        },
        {
          "type": "Control",
          "scope": "#/properties/isActive",
          "options": {
            "gridColumn": "span 3"
          }
        },
        {
          "type": "Control",
          "scope": "#/properties/isDefault",
          "options": {
            "gridColumn": "span 3"
          }
        },
        {
          "type": "Control",
          "scope": "#/properties/pageSetupId",
          "options": {
            "gridColumn": "span 6",
            "customRenderer": "LookupRenderer",
            "lookup": {
              "entity": "DocumentPageSetup",
              "module": "core",
              "displayField": "name",
              "searchFields": [
                "name"
              ],
              "additionalFields": [
                "paperFormat"
              ],
              "minSearchLength": 0
            }
          }
        },
        {
          "type": "Control",
          "scope": "#/properties/description",
          "options": {
            "gridColumn": "span 4",
            "multi": true,
            "rows": 3
          }
        }
      ],
      "i18n": "Section:DocumentTemplate.Details",
      "options": {
        "gridColumn": "span 12"
      }
    },
    {
      "type": "Group",
      "label": "Content",
      "elements": [
        {
          "type": "Control",
          "scope": "#/properties/htmlContent",
          "options": {
            "gridColumn": "span 12",
            "multi": true,
            "rows": 3
          }
        }
      ],
      "i18n": "Section:DocumentTemplate.Content",
      "options": {
        "gridColumn": "span 12"
      }
    }
  ]
};

/**
 * JSON Schema for DocumentTemplate (UPDATE)
 */
export const DocumentTemplateUpdateSchema = {
  "type": "object",
  "title": "DocumentTemplate",
  "description": "Tenant-editable HTML/Scriban template backing a printed PDF document (invoice, offer, ...)",
  "properties": {
    "name": {
      "title": "Name",
      "description": "Display name for this template",
      "type": "string",
      "maxLength": 200
    },
    "documentType": {
      "title": "Document type",
      "description": "Logical document type this template backs",
      "type": "string",
      "enum": [
        "INVOICE"
      ],
      "enumNames": [
        "Invoice"
      ],
      "enumOrdinals": [
        0
      ],
      "enumType": "DocumentTemplateType"
    },
    "htmlContent": {
      "title": "Template HTML",
      "description": "HTML with Scriban placeholders, authored via the template editor",
      "type": "string"
    },
    "isActive": {
      "title": "Active",
      "description": "Only active templates are eligible to be selected at render time",
      "type": "boolean",
      "default": true
    },
    "isDefault": {
      "title": "Default for document type",
      "description": "When true, this is the tenant default template for its documentType",
      "type": "boolean",
      "default": false
    },
    "pageSetupId": {
      "title": "Page setup",
      "description": "Page configuration (paper size, margins, orientation) used when rendering this template; renderer defaults apply when empty",
      "type": [
        "string",
        "null"
      ],
      "format": "entity-lookup",
      "x-lookup": {
        "entity": "DocumentPageSetup",
        "module": "core",
        "displayField": "name",
        "searchFields": [
          "name"
        ],
        "additionalFields": [
          "paperFormat"
        ],
        "minSearchLength": 0,
        "pageSize": 20,
        "recentlyUsedSlot": "core.DocumentTemplate.pageSetupId"
      }
    },
    "description": {
      "title": "Description",
      "description": "Optional free-text notes about this template",
      "type": [
        "string",
        "null"
      ]
    }
  },
  "required": [
    "name",
    "documentType",
    "htmlContent",
    "isActive",
    "isDefault"
  ]
} as unknown as ExtendedJsonSchema;

/**
 * UI Schema for DocumentTemplate (UPDATE)
 */
export const DocumentTemplateUpdateUiSchema: UISchemaElement = {
  "type": "GridLayout",
  "options": {
    "columns": 12,
    "density": "compact",
    "variant": "standard"
  },
  "elements": [
    {
      "type": "Group",
      "label": "Details",
      "elements": [
        {
          "type": "Control",
          "scope": "#/properties/name",
          "options": {
            "gridColumn": "span 6"
          }
        },
        {
          "type": "Control",
          "scope": "#/properties/documentType",
          "options": {
            "gridColumn": "span 6"
          }
        },
        {
          "type": "Control",
          "scope": "#/properties/isActive",
          "options": {
            "gridColumn": "span 3"
          }
        },
        {
          "type": "Control",
          "scope": "#/properties/isDefault",
          "options": {
            "gridColumn": "span 3"
          }
        },
        {
          "type": "Control",
          "scope": "#/properties/pageSetupId",
          "options": {
            "gridColumn": "span 6",
            "customRenderer": "LookupRenderer",
            "lookup": {
              "entity": "DocumentPageSetup",
              "module": "core",
              "displayField": "name",
              "searchFields": [
                "name"
              ],
              "additionalFields": [
                "paperFormat"
              ],
              "minSearchLength": 0
            }
          }
        },
        {
          "type": "Control",
          "scope": "#/properties/description",
          "options": {
            "gridColumn": "span 4",
            "multi": true,
            "rows": 3
          }
        }
      ],
      "i18n": "Section:DocumentTemplate.Details",
      "options": {
        "gridColumn": "span 12"
      }
    },
    {
      "type": "Group",
      "label": "Content",
      "elements": [
        {
          "type": "Control",
          "scope": "#/properties/htmlContent",
          "options": {
            "gridColumn": "span 12",
            "multi": true,
            "rows": 3
          }
        }
      ],
      "i18n": "Section:DocumentTemplate.Content",
      "options": {
        "gridColumn": "span 12"
      }
    }
  ]
};


export interface PanelDescriptor {
  title: string;
  titleKey?: string;
  collapsible?: boolean;
  /** When 'tabs', groups within this panel render as MUI tabs instead of stacked */
  groupLayout?: 'stacked' | 'tabs';
  /** Per-group UISchemas when groupLayout is 'tabs' */
  groupUiSchemas?: Array<{ title: string; titleKey: string; uiSchema: UISchemaElement }>;
  uiSchema: UISchemaElement;
}

export const DocumentTemplateCreatePanels: PanelDescriptor[] | null = null;
export const DocumentTemplateUpdatePanels: PanelDescriptor[] | null = null;


export interface PageTabContentItem {
  type: 'panel' | 'childGrid' | 'extension';
  panelIndex?: number;
  childGrid?: string;
  extension?: string;
}

export interface PageTabDescriptor {
  name: string;
  nameKey: string;
  default: boolean;
  panels: PanelDescriptor[];
  content: PageTabContentItem[];
}

/**
 * Page tab descriptors for DocumentTemplate (CREATE)
 */
export const DocumentTemplateCreatePageTabs: PageTabDescriptor[] = [
  {
    "name": "General",
    "nameKey": "PageTab:DocumentTemplate.General",
    "default": true,
    "panels": [
      {
        "title": "Template",
        "titleKey": "Section:DocumentTemplate.Template",
        "uiSchema": {
          "type": "GridLayout",
          "options": {
            "columns": 12,
            "density": "compact",
            "variant": "standard"
          },
          "elements": [
            {
              "type": "Group",
              "label": "Details",
              "elements": [
                {
                  "type": "Control",
                  "scope": "#/properties/name",
                  "options": {
                    "gridColumn": "span 6"
                  }
                },
                {
                  "type": "Control",
                  "scope": "#/properties/documentType",
                  "options": {
                    "gridColumn": "span 6"
                  }
                },
                {
                  "type": "Control",
                  "scope": "#/properties/isActive",
                  "options": {
                    "gridColumn": "span 3"
                  }
                },
                {
                  "type": "Control",
                  "scope": "#/properties/isDefault",
                  "options": {
                    "gridColumn": "span 3"
                  }
                },
                {
                  "type": "Control",
                  "scope": "#/properties/pageSetupId",
                  "options": {
                    "gridColumn": "span 6",
                    "customRenderer": "LookupRenderer",
                    "lookup": {
                      "entity": "DocumentPageSetup",
                      "module": "core",
                      "displayField": "name",
                      "searchFields": [
                        "name"
                      ],
                      "additionalFields": [
                        "paperFormat"
                      ],
                      "minSearchLength": 0
                    }
                  }
                },
                {
                  "type": "Control",
                  "scope": "#/properties/description",
                  "options": {
                    "gridColumn": "span 4",
                    "multi": true,
                    "rows": 3
                  }
                }
              ],
              "i18n": "Section:DocumentTemplate.Details",
              "options": {
                "gridColumn": "span 12"
              }
            },
            {
              "type": "Group",
              "label": "Content",
              "elements": [
                {
                  "type": "Control",
                  "scope": "#/properties/htmlContent",
                  "options": {
                    "gridColumn": "span 12",
                    "multi": true,
                    "rows": 3
                  }
                }
              ],
              "i18n": "Section:DocumentTemplate.Content",
              "options": {
                "gridColumn": "span 12"
              }
            }
          ]
        }
      }
    ],
    "content": [
      {
        "type": "panel",
        "panelIndex": 0
      }
    ]
  }
];

/**
 * Page tab descriptors for DocumentTemplate (UPDATE)
 */
export const DocumentTemplateUpdatePageTabs: PageTabDescriptor[] = [
  {
    "name": "General",
    "nameKey": "PageTab:DocumentTemplate.General",
    "default": true,
    "panels": [
      {
        "title": "Template",
        "titleKey": "Section:DocumentTemplate.Template",
        "uiSchema": {
          "type": "GridLayout",
          "options": {
            "columns": 12,
            "density": "compact",
            "variant": "standard"
          },
          "elements": [
            {
              "type": "Group",
              "label": "Details",
              "elements": [
                {
                  "type": "Control",
                  "scope": "#/properties/name",
                  "options": {
                    "gridColumn": "span 6"
                  }
                },
                {
                  "type": "Control",
                  "scope": "#/properties/documentType",
                  "options": {
                    "gridColumn": "span 6"
                  }
                },
                {
                  "type": "Control",
                  "scope": "#/properties/isActive",
                  "options": {
                    "gridColumn": "span 3"
                  }
                },
                {
                  "type": "Control",
                  "scope": "#/properties/isDefault",
                  "options": {
                    "gridColumn": "span 3"
                  }
                },
                {
                  "type": "Control",
                  "scope": "#/properties/pageSetupId",
                  "options": {
                    "gridColumn": "span 6",
                    "customRenderer": "LookupRenderer",
                    "lookup": {
                      "entity": "DocumentPageSetup",
                      "module": "core",
                      "displayField": "name",
                      "searchFields": [
                        "name"
                      ],
                      "additionalFields": [
                        "paperFormat"
                      ],
                      "minSearchLength": 0
                    }
                  }
                },
                {
                  "type": "Control",
                  "scope": "#/properties/description",
                  "options": {
                    "gridColumn": "span 4",
                    "multi": true,
                    "rows": 3
                  }
                }
              ],
              "i18n": "Section:DocumentTemplate.Details",
              "options": {
                "gridColumn": "span 12"
              }
            },
            {
              "type": "Group",
              "label": "Content",
              "elements": [
                {
                  "type": "Control",
                  "scope": "#/properties/htmlContent",
                  "options": {
                    "gridColumn": "span 12",
                    "multi": true,
                    "rows": 3
                  }
                }
              ],
              "i18n": "Section:DocumentTemplate.Content",
              "options": {
                "gridColumn": "span 12"
              }
            }
          ]
        }
      }
    ],
    "content": [
      {
        "type": "panel",
        "panelIndex": 0
      }
    ]
  }
];

/**
 * Default values for new DocumentTemplate (extracted from schema defaults)
 */
export const DocumentTemplateCreateDefaults: Partial<Record<string, any>> = {
  "isActive": true,
  "isDefault": false
};

/** Compute create defaults (includes dynamic date defaults resolved at call time). */
export function getDocumentTemplateCreateDefaults(): Partial<Record<string, any>> {
  return { ...DocumentTemplateCreateDefaults };
}

// Legacy exports (for backward compatibility - use create mode)
export const DocumentTemplateSchema = DocumentTemplateCreateSchema;
export const DocumentTemplateUiSchema = DocumentTemplateCreateUiSchema;
